import { useField } from 'formik'
import { DatePicker } from 'antd'
import { enUsData, localeData } from './localeData'
import { FieldConfig } from 'formik/dist/Field'
import { DatePickerProps } from 'antd/lib/date-picker/interface'
import moment from 'moment'
import Styles from './DatePickerField.module.scss'
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar16.svg'

interface DatePickerFieldProps extends Omit<DatePickerProps, 'locale'> {
  locale?: string
  errorMessage?: string
  onChange: (date: moment.Moment | null, dateString: string) => void
  datePickerDropDownClassName?: string
  label?: string
}

export const DatePickerField = ({ locale = 'en-US', label, ...props }: DatePickerFieldProps) => {
  const localData = localeData.get(locale) || enUsData
  return (
    <div className={props.className}>
      {label && <label className={Styles.label}>{label}</label>}
      <div className={Styles.datePickerField}>
        <CalendarIcon className={Styles.icon} />
        <DatePicker
          format={props.format || localData.advancedDayFormat}
          {...props}
          className={Styles.picker}
          dropdownClassName={props.datePickerDropDownClassName}
          suffixIcon={<></>}
        />
        {props.errorMessage && <div className={Styles.errorMessage}>{props.errorMessage}</div>}
      </div>
    </div>
  )
}

interface FormikTimePickerFieldProps extends Pick<DatePickerProps, 'disabledDate' | 'getCalendarContainer'> {
  locale?: string
  className?: string
  datePickerDropDownClassName?: string
  label?: string
  placeholder?: string
  format?: string
  showToday?: boolean
}

export const FormikDatePickerField = (
  props: FormikTimePickerFieldProps & Omit<FieldConfig<moment.Moment | undefined>, 'onChange'>,
) => {
  const { disabledDate, locale, children, ...rest } = props
  const [field, meta, { setValue }] = useField(rest)
  const displayError = meta.touched && meta.error
  const enhancedProps = {
    ...props,
    ...field,
    ...(displayError && { errorMessage: meta.error }),
    onChange: (date: moment.Moment | null) => setValue(date || undefined),
  }
  return <DatePickerField {...enhancedProps} />
}
